export default __webpack_public_path__ + "static/media/login_banner_img.de7fc198.png";